<template>
  <div>
    <vs-button
      style="border-radius: 5px"
      type="gradient"
      color="#f5b55f"
      gradient-color-secondary="#D1913C"
      id="button-with-loading-excel"
      class="vs-con-loading__container"
      @click="yazdirData()"
    >
      <download-excel
        class="btn btn-default"
        :data="excelYazdirilacakData"
        :name="excelName"
        style="padding: 0px !important; color: white"
      >

        {{title}}
      </download-excel>
    </vs-button>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["excelData", "pazaryer", "title"],
  data() {
    return {
      excelName: "",
      excelYazdirilacakData: [],
    };
  },

  methods: {
    yazdirData() {
      var today = new Date();
      this.excelName =
        moment(String(today)).format("DD-MM-YYYY").toString() + this.pazaryer;

      console.log(this.excelData);
      var vs = this.$vs;
      try {
        this.excelYazdirilacakData = this.excelData;
        if (this.excelYazdirilacakData.length == 0) {
          vs.notify({
            title: "Bilgilendirme",
            text: "Yazdırılacak ürün bulunamadı",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        } else {
          this.excelYadirData = [];

          for (let index = 0; index < this.excelData.length; index++) {
            var amountDeger = this.excelData[index].amount,
              grossamountdeger = this.excelData[index].grossAmount;
            if (this.excelData[index].amount.toString().includes(".") == true) {
              amountDeger = this.excelData[index].amount
                .toString()
                .replace(".", ",");
            }
            if (
              this.excelData[index].grossAmount.toString().includes(".") == true
            ) {
              grossamountdeger = this.excelData[index].grossAmount
                .toString()
                .replace(".", ",");
            }
            this.excelYadirData.push({
              Stok_Kodu: this.excelData[index].orderNumber,
              Program: this.excelData[index].program,
              Barkod: this.excelData[index].barcode,
              Adet: this.excelData[index].quantity,
              Tutar: amountDeger,
              Toplam_tutar: grossamountdeger,
              Parti_No: this.excelData[index].partiNo,
            });
          }
          this.excelYazdirilacakData = this.excelYadirData;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>